import { fetchTasksForAddress, fetchTaskPrices } from '../api'
import React from 'react'
import Address from '../shared/address'
import AddressListing from './address-listing'
import UserInfo from './user-info'
import TaskEditModal from '../modals/task-edit-modal'
import AddPropertyModal from '../modals/add-property-modal'
import TaskCard from './my-task-card'
import AccountInfoModal from '../modals/account-info-modal'
import UpgradeServiceModal from '../modals/upgrade-service-modal'
import UpgradeFrequencyModal from '../modals/upgrade-frequency-modal'
import ReactGA from 'react-ga'
import UpdateInstructionsModal from '../modals/update-instructions-modal'
import NotificationModal from '../modals/notification-modal'
import NewTaskModal from '../modals/new-task-modal'
import UpsellOrderModal from '../modals/order-upsell-modal'
import OrderPaymentModal from '../modals/order-payment-modal'
import OrderConfirmationModal from '../modals/order-confirmation-modal'
import {getUpSellIconType} from '../shared/enums/upsell-icon-type'


var tempTasks = []
let modalIcon

const AccountView = React.createClass({
  getInitialState: function () {
    return {
      loginData: this.props.loginData,
      tasksForCurrentAddress: tempTasks,
      userInfoForCol: {
        email: this.props.loginData.customer.email,
        name: this.props.loginData.customer.name,
        phone: this.props.loginData.customer.phone,
        timeZone: this.props.loginData.customer.timeZone
      },
      showEditTaskModal: false,
      showAccountInfoModal: false,
      showUpgradeServiceModal: false,
      showUpgradeFrequencyModal: false,
      showUpdateInstructionsModal: false,
      showUpgradeScheduleModal: false,
      showNotificationModal: false,
      showAddPropertyModal: false,
      showNewTaskModal: false,
      showOrderPaymentModal: false,
      showUpsellModal: false,
      notificationTitle: '',
      notificationContent: '',
      upsellCard: '',
      taskData: '',
      pricingArray: [],
      modalProps: '',
      newAddress: null,
      displayAddress: null,
      confirmationAddress: null
    }
  },
  componentDidMount: function () {
    this.refreshPage(this.props)
  },
  componentWillReceiveProps: function (nextProps) {
    this.refreshPage(nextProps)
  },
  refreshPage: function (props) {
    let address = this.props.currentAddress;
    if(props){
      address = props.currentAddress;
    }
    fetchTasksForAddress(address.addressId).then((data) => {
      this.setState({tasksForCurrentAddress: data})
    })
    if(this.state.pricingArray.length === 0) {

      let tempArray = []
      fetchTaskPrices('MOWLAWN', this.props.currentAddress.addressId).then((data) => {
        for(let i = 0; i < data.data.length; i++) {
          tempArray.push(data.data[i])
        }
        this.setState({pricingArray: tempArray})
      })
    }
  },
  updateFromAccountInfoModal: function (updatedEmail, updatedName, updatedPhone) {
    // Keep an eye on this for weird behavior
    let updatedUserInfo = this.state.userInfoForCol
    updatedUserInfo.email = updatedEmail
    updatedUserInfo.name = updatedName
    updatedUserInfo.phone = updatedPhone

    this.setState({userInfoForCol: updatedUserInfo})
  },
  
  //Start of opening modals
  openEditTaskModal: function (task) {
    ReactGA.pageview('EditTaskModal');
    this.setState({currentTaskDetails: task, showEditTaskModal: true})
  },
  closeEditTaskModal: function () {
    this.setState({showEditTaskModal: false})
  },
  openAccountInfoModal: function () {
    ReactGA.pageview('AccountInfoModal');
    this.setState({showAccountInfoModal: true})
  },
  closeAccountInfoModal: function () {
    this.setState({showAccountInfoModal: false})
  },
  openUpgradeServiceModal: function () {
    ReactGA.pageview('UpgradeServiceModal');
    this.setState({showUpgradeServiceModal: true, showEditTaskModal: false})
  },
  closeUpgradeServiceModal: function () {
    this.setState({showUpgradeServiceModal: false})
    this.refreshPage()
  },
  openUpgradeFrequencyModal: function () {
    ReactGA.pageview('UpgradeFrequencyModal');
    this.setState({showUpgradeFrequencyModal: true, showEditTaskModal: false})
  },
  closeUpgradeFrequencyModal: function () {
    this.setState({showUpgradeFrequencyModal: false})
    this.refreshPage()
  },
  openUpgradeScheduleModal: function () {
    ReactGA.pageview('UpgradeScheduleModal');
    this.setState({showUpgradeScheduleModal: true, showEditTaskModal: false})
  },
  closeUpgradeScheduleModal: function () {
    this.setState({showUpgradeScheduleModal: false})
  },
  openUpdateInstructionsModal: function() {
    ReactGA.pageview('InstructionsModal')
    this.setState({showUpdateInstructionsModal: true, showEditTaskModal: false})
  },
  closeUpdateInstructionsModal: function() {
    this.setState({showUpdateInstructionsModal: false})
    this.refreshPage()
  },
  openNotificationModal: function(closingModal, notificationTitle, notificationContent) {
    ReactGA.pageview('NotificationModal');
    this.setState({showNotificationModal: true, [closingModal]: false, notificationTitle: notificationTitle, notificationContent: notificationContent})
  },
  closeNotificationModal: function() {
    this.setState({showNotificationModal: false})
  },
  openAddPropertyModal: function() {
    this.setState({showAddPropertyModal: true})
  },
  closeAddPropertyModal: function() {
    this.setState({showAddPropertyModal: false})
  },
  openNewTaskModal: function (newAddress, displayAddress) {
    ReactGA.pageview('OrderNewTaskModal');
    ReactGA.event({
      category: 'Order New Task Dashboard Button',
      action: 'click',
      label: 'Order New Task'
    })
    console.log("NEW TASK MODAL : ", newAddress, displayAddress)
    if(newAddress) {
      this.setState({showNewTaskModal: true, showAddPropertyModal: false, newAddress: newAddress, displayAddress: displayAddress})
    }
    else {
      this.setState({showNewTaskModal: true, showAddPropertyModal: false})
    }
  },
  closeNewTaskModal: function () {
    this.setState({showNewTaskModal: false})
  },
  openUpSellOrder: function (cardInfo, newAddress) {
    let upSellType = getUpSellIconType(cardInfo.upSellType)

    let mediaServer = '/common/latest/images/consumer/'
    modalIcon = mediaServer + 'flat-task-icons/' + upSellType.iconsrc
    ReactGA.pageview('UpsellOrderModal/' + upSellType.prettify);

    this.setState({showUpsellModal: true, upsellCard: cardInfo, newAddress: newAddress})
  },
  closeUpsellOpenPayment: function(modalProps, taskData, comment) {
    this.setState({showUpsellModal: false, showProposedTaskModal: false})
    this.openOrderPayment(modalProps, taskData, comment)
  },
  closeUpsellOrder: function () {
    this.setState({showUpsellModal: false})
  },
  openOrderPayment: function (modalProps, taskData, comment) {
    ReactGA.pageview('OrderPaymentModal');
    this.modalProps = modalProps
    this.setState({showOrderPaymentModal: true, modalProps: modalProps, taskData: taskData, comment: comment})
  },
  closeOrderPayment: function () {
    this.setState({showOrderPaymentModal: false})
  },
  openOrderConfirmation: function (orderNumber, price, confirmationAddress) {
    ReactGA.pageview('OrderConfirmationModal');
          ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
		        id: orderNumber,
		        affiliation: 'CUSTOMER_NEW_TASK',
		        revenue: price,
		        tax: '',
		        shipping: '',
		        coupon: ''
	        });
          
              ReactGA.event({
      category: 'Ordered upsell task: #' + orderNumber,
      action: 'click',
      label: 'Order Confirmation Modal'
      
    })
    if(confirmationAddress !== '') {
      this.setState({showOrderConfirmationModal: true, orderNumber: orderNumber, confirmationAddress: confirmationAddress.streetAddress})
    }
    else {
      this.setState({showOrderConfirmationModal: true, orderNumber: orderNumber})
    }
  },
  closeOrderConfirmation: function () {
    this.setState({showOrderConfirmationModal: false})
    this.refreshPage();    
  },
  //End of opening modals

  render: function () {
    if (!this.props.loginData) {
      return (<div/>)
    }

    let loginData = this.props.loginData
    let customerAddresses = []
    for (let i = 0; i < loginData.customer.addresses.length; i++) {
      let addressData = loginData.customer.addresses[i]
      let customerAddress = addressData.streetAddress + ', '+ addressData.city
      customerAddresses.push(customerAddress)
    }


    let show = [];
    let counter = 0
    if(this.state.tasksForCurrentAddress.length !== 0){
      for(let i = 0; i < this.state.tasksForCurrentAddress.length; i++){
        if(this.state.tasksForCurrentAddress[i].taskStatus === 'ACTIVE'){
          show.push(<div key={i} onClick={() => this.openEditTaskModal(this.state.tasksForCurrentAddress[i])} className='clickable'>
                      <TaskCard btnId={counter} key={i} openEditTaskModal={this.openEditTaskModal} task={this.state.tasksForCurrentAddress[i]}/>
                    </div>)
          counter++
        }

      }
    }
    let keycloakToken = JSON.parse(sessionStorage.getItem("keycloakToken"));
    // console.log("ACCOUNT", this.state.newAddress)
    return (
      <div>

        <TaskEditModal task={this.state.currentTaskDetails} show={this.state.showEditTaskModal} hide={this.closeEditTaskModal} openUpgradeServiceModal={this.openUpgradeServiceModal} openUpgradeFrequencyModal={this.openUpgradeFrequencyModal} openUpgradeScheduleModal={this.openUpgradeScheduleModal} openUpdateInstructionsModal={this.openUpdateInstructionsModal} fullComponent={true}/>
        {keycloakToken && keycloakToken.isEmpty?
            <AccountInfoModal info={this.state.userInfoForCol} update={this.updateFromAccountInfoModal} show={this.state.showAccountInfoModal} hide={this.closeAccountInfoModal} />:
            <AccountInfoModal info={this.state.userInfoForCol} loginData={this.props.loginData} update={this.updateFromAccountInfoModal} show={this.state.showAccountInfoModal} hide={this.closeAccountInfoModal} />
        }
        <UpgradeServiceModal show={this.state.showUpgradeServiceModal} hide={this.closeUpgradeServiceModal} task={this.state.currentTaskDetails} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
        <UpgradeFrequencyModal show={this.state.showUpgradeFrequencyModal} hide={this.closeUpgradeFrequencyModal} task={this.state.currentTaskDetails} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
        <UpdateInstructionsModal show={this.state.showUpdateInstructionsModal} hide={this.closeUpdateInstructionsModal} modalCard={this.state.currentTaskDetails} openNotificationModal={this.openNotificationModal}/>
        <NotificationModal hide={this.closeNotificationModal} show={this.state.showNotificationModal} title={this.state.notificationTitle} content={this.state.notificationContent}/>
        <AddPropertyModal show={this.state.showAddPropertyModal} hide={this.closeAddPropertyModal} refreshPage={this.refreshPage} openNotificationModal={this.openNotificationModal} openNewTaskModal={this.openNewTaskModal}/>
        <NewTaskModal modalHeader='Order New Task' modalSubHeader='What kind of task are you looking for?' show={this.state.showNewTaskModal} hide={this.closeNewTaskModal} openCustom={this.openCustomTask} openUpsellModal={this.openUpSellOrder} login={this.props.loginData} addressId={this.state.currentlySelectedAddressId} newAddress={this.state.newAddress}/>
        <OrderPaymentModal login={this.props.loginData} modalProps={this.state.modalProps} newAddress={this.state.newAddress} displayAddress={this.state.displayAddress} comment={this.state.comment} taskData={this.state.taskData} show={this.state.showOrderPaymentModal} hide={this.closeOrderPayment} openConfirmation={this.openOrderConfirmation} openNotificationModal={this.openNotificationModal}/>
        <OrderConfirmationModal login={this.props.loginData} confirmationAddress={this.state.confirmationAddress} show={this.state.showOrderConfirmationModal} hide={this.closeOrderConfirmation} orderNumber={this.state.orderNumber} modalProps={this.state.modalProps} taskData={this.state.taskData} />
        <UpsellOrderModal newAddress={this.state.newAddress} address={this.props.currentAddress.addressId} streetAddress={this.props.currentAddress.streetAddress} icon={modalIcon} card={this.state.upsellCard} login={this.props.loginData} show={this.state.showUpsellModal} hide={this.closeUpsellOrder} openPayment={this.closeUpsellOpenPayment}/>


        <div className='container-cards concrete-gray-background'>
          <div className='row'>
            <div className='col-xs-12 history-wrap'>
              <div className='row pull-down-sm-1'>
                <div className='col-sm-5 col-xs-12'>
                  <h3 className='hidden-xs' style={{textAlign: 'left'}}>My Account</h3>
                  <h3 className='visible-xs'>My Account</h3>
                </div>
                <div className='col-sm-7 col-xs-12 text-right address'>
                  <Address addresses={customerAddresses} curIndex={this.props.curAddressIndex} onChange={this.props.reportAddressChange} />
                </div>
              </div>
            </div>
          </div>

          <div className='pull-down-sm-3 row'>
            <div className='col-sm-6'>
              <div className='hidden-xs'>
                <h4 className='text-center'>My Info</h4>
                <UserInfo info={this.state.userInfoForCol} backgroundColor show={this.openAccountInfoModal} />
              </div>
              <div>
                <hr className='visible-xs' style={{borderColor: '#bebebe'}}/>
                <h4 className='text-center pull-down-xs-2'>My Property</h4>
                <AddressListing address={this.props.currentAddress} key={0} hasPullDown={false} topBar={false} />
              </div>
              <div className='row'>
                <div style={{width:'50%', margin:'auto'}}>
                  <button type='button' className='center-block btn btn-info btn-sm btn-block cerulean-blue-background account-btn' onClick={this.openAddPropertyModal}>Add property</button>
                </div>
              </div>
            </div>
            <div className='col-xs-12 col-sm-6' style={{marginBottom: 20}}>
              <hr className='visible-xs' style={{borderColor: '#bebebe'}}/>
              <h4 className='text-center account-task-list-header'>My Tasks</h4>
              {show}
            </div>
            </div>
            <div className='visible-xs pull-down-xs-2'>
              <hr className='visible-xs' style={{borderColor: '#bebebe'}}/>
                <h4 className='text-center'>My Info</h4>
                <UserInfo info={this.state.userInfoForCol} show={this.openAccountInfoModal} />
            </div>
        </div>
      </div>
    )
  }
})

export default AccountView


// WEBPACK FOOTER //
// ./src/components/account/account.jsx